import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { OcrSuggestionResponse, StaticAssets, StaticAssetsService } from 'src/app/services/static-assets';
import { environment } from 'src/environments/environment';
import { from } from 'rxjs';
import { ContextService } from 'src/app/services/context.service';
import { MsCallService } from 'src/app/services/ms-call.service';
import { SessionService } from 'src/app/services/session.service';


@Injectable()
export class FaceIdHandler {

  formatHeaders = {};
  isCallCenter: boolean;

  constructor(
    private http: HttpClient,
    private staticAssetsService: StaticAssetsService,
    private contextService: ContextService,
    private msCallService: MsCallService,
    private sessionService: SessionService) {
      this.isCallCenter = this.sessionService.isCallCenter === 'true' ? true : false;
      this.formatHeaders =  new HttpHeaders ({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'channel': this.contextService.getChannelName(),
        'country': 'PE',
        'commerce': 'Banco',
        'x-flow-session-id': this.msCallService.getFlowSessionId(),
        'x-flow-transaction-id': this.msCallService.getNewId(),
        'x-session-id': this.msCallService.getSessionId(),
        'iscallcenter': String(this.isCallCenter),
        'x-flow-type': 'account'
      });
    }

  getSuggestions(): Observable<OcrSuggestionResponse> {
    return this.staticAssetsService.getStaticResources<OcrSuggestionResponse>(StaticAssets.suggestionData);
  }

  public requestApplication(): Observable<any> {
    const url = environment.SERVICES.HOST + environment.SERVICES.FACE_ID_APPLICATION.URI;
    const headers = this.formatHeaders;
    return this.http.post(url, {}, { headers });
  }

  public applicationVerify(soliId: string, zcode: string): Observable<any> {
    const url = environment.SERVICES.HOST + environment.SERVICES.FACE_ID_VERIFICATION.URI;
    const request = {
      soliId,
      zcode
    };
    const headers = this.formatHeaders;
    return this.http.post(url, request, { headers });
  }

  public partialAttempt(zcode: string, description: string, stage: string): Observable<any> {
    const url = environment.SERVICES.HOST + environment.SERVICES.PARTIAL_ATTEMPT;
    const request = {
      zcode,
      description,
      stage
    };
    const headers = this.formatHeaders;
    return this.http.post(url, request, { headers });
  }
}
